export class User {
  userUuid: string;
  username: string;
  tenantUUID: string;
  organizationUUID: string;
  email: string;
  phone: string | object;
  language: string;
  mailLanguage: string;
  mailTimezone: string;
  timeZone: string;
  organization: UserOrganization;
  profile: UserProfile;
  emailVerified: boolean;
  enabled: boolean;
  firstName: string;
  lastName: string;
  requieredActions: string[];
  superadminApplications: string[];
  adminApplications: string[];
  viewerApplications: string[];
  groups: UserGroup[];
  blocked: boolean;
  eCommerceUser: boolean;
}

export class UserGroup {
  machineGroupUuid: string;
}

export class UserOrganization {
  name: string;
  orgCode: string;
  organizationUuid: string;
  organizationType: UserOrganizationType;
  parent: UserOrganization;
}

export class UserOrganizationType {
  name: string;
  root: boolean;
}

export class UserProfile {
  profileUuid: string;
  name: string;
}

export class UserApplication {
  userUuid: string;
  username: string;
  tenantUUID: string;
  organizationUUID: string;
  role: string;
  machines: MachineUser[];
  availableMachines: MachineUser[];
}

export class MachineUser {
  userUuid: string;
  code: string;
  name: string;
  description: string;
}
